var APPENDIX_EVIDENCE_TABLES_ID, APPENDIX_EVIDENCE_TABLES_TITLE, APPENDIX_REFERENCES_ID, APPENDIX_REFERENCES_SECTION_ID, APPENDIX_REFERENCES_TITLE, Editor, W, exportEpiditorContent, getContentPromise, getContentWithReferencesPromise, getDraftImageIds, getHyperlinkPluginOptions, hydrateDraftAttachments, isDraftContent, isEmptyNonStringContent, isImmutable, mediator, processMdgCodes, processTitle, referencesInsertExtension, removeHTMLNode, renderDraftContentSPP, toPlainContent, xmlCharactersMap, xmlRegex;

Editor = Epiditor["default"];

renderDraftContentSPP = require('lib/draft_utils').renderDraftContentSPP;

getHyperlinkPluginOptions = require('lib/document_sections_v2_helper').getHyperlinkPluginOptions;

referencesInsertExtension = require('components/document_sections/v2/editor_extensions/insert/insert');

removeHTMLNode = require('base/lib/utils').removeHTMLNode;

W = require('when/when');

mediator = require('mediator');

isImmutable = require('lib/immutable_utils').isImmutable;

APPENDIX_EVIDENCE_TABLES_ID = 'appendix-evidence-tables';

APPENDIX_EVIDENCE_TABLES_TITLE = $.t('docsec:v2.appendix_evidence_tables_title');

APPENDIX_REFERENCES_ID = 'appendix-references';

APPENDIX_REFERENCES_SECTION_ID = 'appendix-references-section';

APPENDIX_REFERENCES_TITLE = $.t('docsec:v2.appendix_references_title');

exportEpiditorContent = function(_arg) {
  var additionalSectionData, chapterPath, chaptersPaths, content, exportDate, guidelineId, linkPrefix, sectionId, sectionParentPaths, title, type;
  additionalSectionData = _arg.additionalSectionData, chapterPath = _arg.chapterPath, chaptersPaths = _arg.chaptersPaths, content = _arg.content, exportDate = _arg.exportDate, guidelineId = _arg.guidelineId, linkPrefix = _arg.linkPrefix, sectionId = _arg.sectionId, sectionParentPaths = _arg.sectionParentPaths, title = _arg.title, type = _arg.type;
  return W.promise(function(resolve) {
    var chapterLinkURLProvider, element, onLoad, reactContainer, sectionLinkURLProvider, sectionLinksExtension;
    sectionLinksExtension = require('components/document_sections/v2/editor_extensions/section_links/section_links');
    sectionLinkURLProvider = function(linkedSectionId) {
      var sectionParentPath;
      sectionParentPath = sectionParentPaths[linkedSectionId];
      return "" + linkPrefix + sectionParentPath + "#" + linkedSectionId;
    };
    chapterLinkURLProvider = function(linkedChapterId) {
      return "" + linkPrefix + chaptersPaths[linkedChapterId];
    };
    reactContainer = document.createElement('div');
    onLoad = function(_arg1) {
      var dom;
      dom = _arg1.dom;
      return _.defer(function() {
        var div, fullReferencesData, htmlContent, references;
        div = document.createElement('div');
        $(dom).find('span.epiditor--annotation').removeClass('epiditor--annotation');
        $(dom).find('span.changed').remove();
        $(dom).find('span.changed-reverted').removeClass('changed-reverted');
        $(dom).find('br.ProseMirror-trailingBreak').remove();
        htmlContent = $(div).addClass('epiditor--container').prop('innerHTML', dom.outerHTML).attr('id', sectionId).prop('outerHTML');
        references = [];
        fullReferencesData = [];
        $(div).find('span.reference').each(function(_idx, element) {
          var refIds, _ref, _ref1;
          refIds = (_ref = element.dataset['refIds']) != null ? _ref : '';
          if (!_.isEmpty(refIds)) {
            references.push(refIds.split(','));
          }
          return fullReferencesData.push(JSON.parse((_ref1 = element.dataset['refs']) != null ? _ref1 : '{}'));
        });
        removeHTMLNode(div);
        ReactDOM.unmountComponentAtNode(reactContainer);
        removeHTMLNode(reactContainer);
        return resolve({
          references: references,
          referencesFromTables: [],
          fullReferencesData: fullReferencesData,
          sections: [
            _.extend({}, additionalSectionData, {
              id: "" + guidelineId + "/" + chapterPath + "/" + sectionId,
              guid: sectionId,
              chapterId: chapterPath,
              guidelineId: guidelineId,
              htmlContent: htmlContent,
              lastModified: exportDate,
              title: (title != null) && title !== '' ? title : void 0,
              type: type
            })
          ]
        });
      });
    };
    element = React.createElement(Editor, {
      extensions: [referencesInsertExtension(true), sectionLinksExtension(sectionLinkURLProvider, chapterLinkURLProvider)],
      initialState: content,
      mode: 'readonly',
      onLoad: onLoad,
      pluginProps: {
        hyperlink: getHyperlinkPluginOptions(true)
      }
    });
    return ReactDOM.render(element, reactContainer);
  });
};

processMdgCodes = function(codes) {
  return _.chain(codes).values().map(function(code) {
    return {
      type: code.codeType,
      value: code.value
    };
  }).sortBy(['type', 'value']).value();
};

xmlCharactersMap = {
  '&': '&amp;',
  '<': '&lt;',
  '>': '&gt;',
  '"': '&quot;',
  "'": '&apos;'
};

xmlRegex = new RegExp("[" + (_.keys(xmlCharactersMap).join('')) + "]", 'g');

processTitle = function(title) {
  return title.replace(xmlRegex, function(c) {
    return xmlCharactersMap[c];
  });
};

toPlainContent = function(content) {
  if (content == null) {
    return content;
  }
  if (content.toJS != null) {
    return content.toJS();
  } else {
    return content;
  }
};

isEmptyNonStringContent = function(content) {
  var plain;
  if (!((content != null) && !_.isString(content))) {
    return false;
  }
  plain = toPlainContent(content);
  if (_.isArray(plain) && _.isEmpty(plain)) {
    return true;
  }
  return _.isObject(plain) && !_.isArray(plain) && _.isEmpty(plain);
};

isDraftContent = function(content) {
  var blocks, contentToCheck;
  if (!((content != null) && !_.isString(content))) {
    return false;
  }
  if (isEmptyNonStringContent(content)) {
    return false;
  }
  contentToCheck = content.toJS != null ? content : Immutable.fromJS(content);
  if ((contentToCheck != null ? contentToCheck.has : void 0) == null) {
    return false;
  }
  if (!(contentToCheck.has('blocks') && contentToCheck.has('entityMap'))) {
    return false;
  }
  blocks = contentToCheck.get('blocks');
  return Immutable.List.isList(blocks) || _.isArray(blocks);
};

getDraftImageIds = function(content) {
  var contentToCheck, entityMap;
  if (!isDraftContent(content)) {
    return [];
  }
  contentToCheck = Immutable.fromJS(content);
  entityMap = contentToCheck.get('entityMap', Immutable.Map());
  return entityMap.reduce(function(imageIds, entity) {
    var imageId;
    if (entity.get('type') !== 'IMAGE') {
      return imageIds;
    }
    imageId = entity.getIn(['data', 'imageId']);
    if (imageId != null) {
      imageIds.push(imageId);
    }
    return imageIds;
  }, []);
};

hydrateDraftAttachments = function(content, attachments, attachmentSource) {
  var attachmentsToCheck, dbName, docId, imageIds, missingImageIds;
  if (attachments == null) {
    attachments = {};
  }
  if (attachmentSource == null) {
    attachmentSource = {};
  }
  imageIds = _.uniq(getDraftImageIds(content));
  attachmentsToCheck = (attachments != null ? attachments.toJS : void 0) != null ? attachments : Immutable.fromJS(attachments != null ? attachments : {});
  missingImageIds = _.filter(imageIds, function(imageId) {
    return !attachmentsToCheck.getIn([imageId, 'data']);
  });
  if (_.isEmpty(missingImageIds)) {
    return W.resolve(attachmentsToCheck);
  }
  dbName = attachmentSource.dbName, docId = attachmentSource.docId;
  if (!(dbName && docId)) {
    return W.resolve(attachmentsToCheck);
  }
  return mediator.services.storePersistenceAdapter.fetch(dbName, docId, {
    attachments: true
  }).then(function(doc) {
    var _ref;
    return attachmentsToCheck.merge(Immutable.fromJS((_ref = doc != null ? doc._attachments : void 0) != null ? _ref : {}));
  })["catch"](function() {
    return attachmentsToCheck;
  });
};

getContentWithReferencesPromise = function(id, content, title, attachments, attachmentSource) {
  var contentToPass;
  if (title == null) {
    title = '';
  }
  if (attachments == null) {
    attachments = {};
  }
  if (attachmentSource == null) {
    attachmentSource = {};
  }
  if (_.isString(content)) {
    return W.resolve({
      htmlContent: content,
      references: [],
      referencesFromTables: [],
      fullReferencesData: []
    });
  } else if (isDraftContent(content)) {
    contentToPass = Immutable.Map.isMap(content) ? content.toJS() : content || '';
    return hydrateDraftAttachments(contentToPass, attachments, attachmentSource).then(function(resolvedAttachments) {
      return {
        htmlContent: renderDraftContentSPP(contentToPass, {
          attachments: resolvedAttachments
        }),
        references: [],
        referencesFromTables: [],
        fullReferencesData: []
      };
    });
  } else {
    return exportEpiditorContent({
      chapterPath: '',
      chaptersPaths: {},
      content: Immutable.Map.isMap(content) ? content.toJS() : content || '',
      exportDate: '',
      guidelineId: '',
      linkPrefix: '',
      sectionId: id,
      sectionParentPaths: {},
      title: title,
      type: 'text'
    }).then(function(result) {
      var _ref, _ref1, _ref2, _ref3, _ref4;
      return {
        htmlContent: (_ref = (_ref1 = result.sections[0]) != null ? _ref1.htmlContent : void 0) != null ? _ref : '',
        references: (_ref2 = result.references) != null ? _ref2 : [],
        referencesFromTables: (_ref3 = result.referencesFromTables) != null ? _ref3 : [],
        fullReferencesData: (_ref4 = result.fullReferencesData) != null ? _ref4 : []
      };
    });
  }
};

getContentPromise = function(id, content, attachments, attachmentSource) {
  if (attachments == null) {
    attachments = {};
  }
  if (attachmentSource == null) {
    attachmentSource = {};
  }
  return getContentWithReferencesPromise(id, content, '', attachments, attachmentSource).then(function(_arg) {
    var htmlContent;
    htmlContent = _arg.htmlContent;
    return htmlContent;
  });
};

module.exports = {
  APPENDIX_EVIDENCE_TABLES_ID: APPENDIX_EVIDENCE_TABLES_ID,
  APPENDIX_EVIDENCE_TABLES_TITLE: APPENDIX_EVIDENCE_TABLES_TITLE,
  APPENDIX_REFERENCES_ID: APPENDIX_REFERENCES_ID,
  APPENDIX_REFERENCES_SECTION_ID: APPENDIX_REFERENCES_SECTION_ID,
  APPENDIX_REFERENCES_TITLE: APPENDIX_REFERENCES_TITLE,
  exportEpiditorContent: exportEpiditorContent,
  getContentPromise: getContentPromise,
  getContentWithReferencesPromise: getContentWithReferencesPromise,
  isDraftContent: isDraftContent,
  isEmptyNonStringContent: isEmptyNonStringContent,
  processMdgCodes: processMdgCodes,
  processTitle: processTitle,
  toPlainContent: toPlainContent
};
